import { h, Component } from 'preact';
import { sortObjectByOrder, accessNested, joinClasses, getStylingImagePath } from 'utils/utils';
import { Link } from 'components/core/link/link.js';
import { getSizeBasedTT } from 'utils/clientUtils';
import { useDynamicAssetFolder, IMAGE_REGION_ROOT_DYNAMIC } from 'utils/assets';
import HTML from 'components/core/html/html';
import s from 'components/shared/homeEntButtons/homeEntButtons.sss';
import CalendarRemind from 'components/shared/calendarRemind/calendarRemind';
import Store from 'store/store';
import * as actions from 'store/actions';

export default class HomeEntButtons extends Component {

	constructor(props) {
		super(props);

		this.renderFormat = this.renderFormat.bind(this);
		this.renderVendor = this.renderVendor.bind(this);
		this.sizeBasedTT = this.sizeBasedTT.bind(this);
	}

	componentDidMount() {
		if (typeof window.firstSessionVisit === 'undefined') {
			window.firstSessionVisit = true;
		} else {
			window.firstSessionVisit = false;
		}
	}

	gaTrack(url, trackingPrefix, name, pageId) {
		Store.emit(actions.HOMEENT_VENDOR_CLICKED, url, trackingPrefix, null, pageId, name);
	}

	renderVendor(data, key) {
		const { useCalendarRemindVendor = {}, transparentNoLink = false } = this.props.pageData;
		const {
			name = '',
			trackingPrefix = '',
			logo = '',
			url = '',
			pageId = '',
			caption = '',
			alt = '',
			inviteTitle = '',
			inviteDescription = '',
			inviteDate = '',
			useCalendar,
			useLinkOut,
		} = data;
		const trackId = `${trackingPrefix} ${name}`;

		if ((!useCalendarRemindVendor.enabled && !useCalendar) || useLinkOut) {
			let useCalRemindStyle = useCalendarRemindVendor.enabled && useLinkOut ? true : false;
			let className = data.trackId || data.vendorName || data.name || '';
			let imageClassname;
			className = className.toLowerCase().replace(/[^a-z0-9]+/g, '');
			if (className) {
				imageClassname = 'img-' + className;
				className = 'button-' + className;
			}
			let inner = [
				<span class={s.hiddenText} key="hidden-text">{name}</span>,
				<img class={joinClasses(s.vendorLogo, imageClassname)} src={logo} alt={alt} key="image" />
			];
			let content;
			if (url || pageId) {
				content = (
					<Link
						class={joinClasses(useCalRemindStyle ? s.calRemindStyle : s.link, className)}
						href={url}
						pageId={pageId}
						trackId={trackId}
						extraOnClick={() => this.gaTrack(url, trackingPrefix, name, pageId)}
						target={url ? '_blank' : ''}
						renderCustomChild
						key="content-link"
					>
						{inner}
					</Link>
				);
			} else {
				let style = transparentNoLink ? s.noLink : useCalRemindStyle ? s.calRemindStyle : s.link;
				content = (
					<div class={joinClasses(style, className)} key="content-no-link">{inner}</div>

				);
			}
			// Link out mode
			return (
				<li class={s.vendor} key={key}>
					{content}
					<div class={s.caption} key="caption">{caption}</div>
				</li>
			);
		}

		// Caledar mode
		const { appData, pageData, client, activePage } = this.props;

		const releaseDate = appData.options.useBoxOfficeCalendar && appData.meta.dates.boxOffice
			? appData.meta.dates.boxOffice
			: appData.meta.dates.release;
		const { inviteTitle: eventTitle = '', inviteDescription: eventDescription = '' } = useCalendarRemindVendor;
		const customTitle = inviteTitle ? inviteTitle : eventTitle.replace('%VENDOR%', name);
		const customDescription = inviteDescription ? inviteDescription : eventDescription.replace('%VENDOR%', name).replace('%LINK%', url);

		const customPrompt = <img class={s.vendorLogo} src={logo} alt={alt} />;
		return (
			<li class={s.vendor}>
				<CalendarRemind
					class={s.vendorCal}
					key="showtimesRemind"
					pageData={pageData}
					copy={appData.copy}
					appUrl={appData.meta.url}
					releaseDate={releaseDate}
					sharedImageRoot={appData.urls.roots.sharedImages}
					useReveal
					client={client}
					activePage={activePage}
					customPrompt={customPrompt}
					customTitle={customTitle}
					customDate={inviteDate || null}
					customDescription={customDescription}
				/>
			</li>
		);
	}

	renderFormat(data, key) {
		let className = data.title;
		if (className) {
			className = 'format-' + className.toLowerCase().replace(/[^a-z0-9]+/g, '');
		}
		return (
			<section class={joinClasses(s.vendors, className)} key={key}>
				<HTML tag="h1" class={s.title} content={data.title} />
				<ul class={s.list}>
					{sortObjectByOrder(data.list, this.renderVendor)}
				</ul>
			</section>
		);
	}

	sizeBasedTT(data) {
		const img = getSizeBasedTT(data, this.props.client, 'tt-homeent.png');
		const imgNoExtension = img.split('.')[0];
		const imgRoot = IMAGE_REGION_ROOT_DYNAMIC;
		const ttPath = getStylingImagePath(this.props.appData, imgNoExtension, imgRoot + '/' + img);
		return useDynamicAssetFolder(ttPath);
	}

	render({ appData, pageData }) {

		const { vendors: vendorData = {}, poster = '', alternateTT = {}, pageTitle = '' } = pageData;
		const { copy } = appData;

		const imageRegionRoot = IMAGE_REGION_ROOT_DYNAMIC;
		const filmTitle = accessNested(appData, 'meta.title.locale');
		let tt = alternateTT ? this.sizeBasedTT(alternateTT) : `${imageRegionRoot}/tt-homeent.png`;
		tt = useDynamicAssetFolder(tt);

		const alt = copy.$HOME_TITLE_TREATMENT_SEO || filmTitle;
		return (
			<main class={joinClasses(s.wrapper, poster && s.posterLayout)}>
				<div class={s.container}>
					<h1 class={poster ? s.poster : s.tt} key="poster-tt">
						<img
							class={s.image}
							src={poster || tt}
							alt={alt}
						/>
						<span class={s.hiddenText}>{alt}</span>
					</h1>
					{pageTitle && <HTML class={s.pageTitle} content={pageTitle} markdown key="page-title" />}
					{sortObjectByOrder(vendorData, this.renderFormat)}
				</div>
			</main>
		);
	}
}
